<template>
    <base-form @submit="$emit('submit', form)">
        <div class="border-b px-6 pt-6">
            <h6 class="text-center font-semibold text-lg font-normal mb-3">
                Login
            </h6>

            <validator-alert :sid="sid" />

            <form-item
                :sid="sid"
                :is-required="true"
                name="email"
            >
                <template slot="label">Email</template>

                <input-text
                    v-model="form.email"
                    :sid="sid"
                    :autofocus="!form.email"
                    :disabled="is_saving"
                    name="email"
                    type="email"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="password"
            >
                <template slot="label">Password</template>

                <input-text
                    v-model="form.password"
                    :sid="sid"
                    :disabled="is_saving"
                    :autofocus="!!form.email"
                    name="password"
                    type="password"
                />
            </form-item>

            <form-item
                :sid="sid"
                name="remember"
            >
                <label class="flex items-center cursor-pointer">
                    <input-checkbox
                        v-model="form.remember"
                        :sid="sid"
                        :disabled="is_saving"
                        name="remember"
                        class="mr-3"
                    />

                    <div class="leading-none">Remember me</div>
                </label>
            </form-item>
        </div>

        <base-form-footer
            :is-responsive="false"
            :show-required="false"
            class="rounded-b"
        >
            <base-button
                :is-loading="is_saving"
                class="btn-blue w-full"
            >
                Login
            </base-button>

            <div class="text-center text-xs leading-tight pt-3">
                <router-link
                    :to="{ name: 'auth.password-resets.create' }"
                    class="text-blue no-underline"
                >
                    Forgot your password?
                </router-link>
            </div>
        </base-form-footer>

        <slot name="modals" />
    </base-form>
</template>

<script>
    import local from '../store/local'

    export default {
        props: {
            sid: {
                type: String,
                required: true
            },
            isSaving: {
                type: Boolean,
                required: true
            }
        },
        data () {
            return {
                form: {
                    email: '',
                    password: '',
                    remember: true
                }
            }
        },
        computed: {
            is_saving () {
                return this.isSaving
            }
        },
        watch: {
            'form.email' () {
                local.set('guest-email', this.form.email)
            }
        },
        created () {
            if (!this.form.email) {
                this.form.email = local.get('guest-email')
            }
        }
    }
</script>
